/**
 * Every path in one place, so a rename is one edit rather than a grep.
 *
 * `as const` matters: it makes these string literals rather than `string`, so a
 * typo in a <Link to={...}> is a compile error.
 */
export const ROUTES = {
  home: '/',
  login: '/login',
  resetPassword: '/reset-password',
  dashboard: '/dashboard',
  reviewLinks: '/review-links',
  notifications: '/notifications',
  licences: '/licences',
  licenceDetail: (id: string) => `/licences/${id}`,
  downloads: '/downloads',
  issues: '/issues',
  manual: '/manual',
  faq: '/faq',
  settings: '/settings',
  team: '/team',
  profile: '/profile',
  security: '/security',
} as const;

/** Reachable without a session. Everything else redirects to login. */
export const PUBLIC_ROUTES: string[] = [ROUTES.login, ROUTES.resetPassword];
